export default "__VITE_PUBLIC_ASSET__c00d066b__"